// extracted by mini-css-extract-plugin
var _1 = "TableElementForm_root__aa6c6";
export { _1 as "root" }
